export class UpdateClassificationPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classificationPolicy",
            "baseName": "classificationPolicy",
            "type": "ClassificationPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateClassificationPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
